module.exports = __webpack_public_path__ + "img/kc.66c55850.svg";